import {Component, Material, Texture} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {createContext} from 'react';

/**
 * ui-textures-manager
 */
export class UiTexturesManager extends Component {
    /* Properties that are configurable in the editor */
    static TypeName = 'ui-textures-manager';

    // Singleton
    private static _instance: UiTexturesManager;
    static get instance(): UiTexturesManager {
        return UiTexturesManager._instance;
    }

    private static _context: React.Context<UiTexturesManager> = null;
    static get context() {
        if (!UiTexturesManager._context) {
            UiTexturesManager._context = createContext(UiTexturesManager.instance);
        }
        return UiTexturesManager._context;
    }

    @property.texture({required: true})
    arrow: Texture;
    @property.texture({required: true})
    buttonAd: Texture;
    @property.texture({required: true})
    buttonAdClean: Texture;
    @property.texture({required: true})
    buttonFruitsmasher: Texture;
    @property.texture({required: true})
    buttonLock: Texture;
    @property.texture({required: true})
    buttonShare: Texture;
    @property.texture({required: true})
    buttonShield: Texture;
    @property.texture({required: true})
    buttonBuyBomb: Texture;
    @property.texture({required: true})
    buttonClockMagnet: Texture;
    @property.texture({required: true})
    buttonDestroyCountdown: Texture;
    @property.texture({required: true})
    checklist: Texture;
    @property.texture({required: true})
    coinDuplicator: Texture;
    @property.texture({required: true})
    coinIconSmall: Texture;
    @property.texture({required: true})
    home: Texture;
    @property.texture({required: true})
    restart: Texture;
    @property.texture({required: true})
    iconInventory: Texture;
    @property.texture({required: true})
    iconLeaderboard: Texture;
    @property.texture({required: true})
    iconMalware: Texture;
    @property.texture({required: true})
    iconOptions: Texture;
    @property.texture({required: true})
    iconPerk: Texture;
    @property.texture({required: true})
    iconCherry: Texture;
    @property.texture({required: true})
    info: Texture;
    @property.texture({required: true})
    lock: Texture;
    @property.texture({required: true})
    logoWide: Texture;
    @property.texture({required: true})
    malRainbowFruit: Texture;
    @property.texture({required: true})
    moreGames: Texture;
    @property.texture({required: true})
    mushroomSlicer: Texture;
    @property.texture({required: true})
    musicIcon: Texture;
    @property.texture({required: true})
    musicIconDisabled: Texture;
    @property.texture({required: true})
    offers: Texture;
    @property.texture({required: true})
    soundSpeaker: Texture;
    @property.texture({required: true})
    soundSpeakerDisabled: Texture;
    @property.texture({required: true})
    theNuke: Texture;
    @property.texture({required: true})
    trophyIcon: Texture;
    @property.texture({required: true})
    trophyWhite: Texture;
    @property.texture({required: true})
    universalNo: Texture;
    @property.texture({required: true})
    whiteCircle: Texture;
    @property.texture({required: true})
    whiteRing: Texture;
    @property.texture({required: true})
    whiteSquare: Texture;

    @property.texture({required: true})
    uiBgArctic: Texture;
    @property.texture({required: true})
    uiBgCandyland: Texture;
    @property.texture({required: true})
    uiBgDesert: Texture;
    @property.texture({required: true})
    uiBgForest: Texture;
    @property.texture({required: true})
    uiBgIsland: Texture;
    @property.texture({required: true})
    uiBgMoon: Texture;
    @property.texture({required: true})
    uiBgSwamp: Texture;
    @property.texture({required: true})
    uiBgWuk: Texture;

    closeButton: Texture;
    @property.texture({required: true})
    finger: Texture;
    @property.texture({required: true})
    leaderBoardStar: Texture;
    @property.texture({required: true})
    leaderBoardNormal: Texture;
    @property.texture({required: true})
    leaderBoardGold: Texture;
    @property.texture({required: true})
    leaderBoardSilver: Texture;
    @property.texture({required: true})
    leaderBoardBronze: Texture;
    @property.texture({required: true})
    leaderBoardEmpty: Texture;

    @property.texture({required: true})
    rainbowFruit: Texture;
    @property.texture({required: true})
    tntBlob: Texture;
    @property.texture({required: true})
    comboChainBonus: Texture;
    @property.texture({required: true})
    scoreModifier: Texture;
    @property.texture({required: true})
    starBooster: Texture;
    @property.texture({required: true})
    timeBonus: Texture;

    @property.texture({required: true})
    tachometer: Texture;
    @property.texture({required: true})
    tachometerArrow: Texture;
    @property.texture({required: true})
    pauseIcon: Texture;

    @property.texture({required: true})
    gameModeStar: Texture;
    @property.texture({required: true})
    gameModeCupcake: Texture;
    @property.texture({required: true})
    gameModeNormal: Texture;
    @property.texture({required: true})
    gameModeSkull: Texture;
    @property.texture({required: true})
    gameModeMatch: Texture;
    @property.texture({required: true})
    gameModeTimed: Texture;
    @property.texture({required: true})
    gameModeMushroom: Texture;

    @property.texture({required: true})
    diffStar: Texture;
    @property.texture({required: true})
    autoPop: Texture;

    @property.texture({required: true})
    check: Texture;

    @property.texture({required: true})
    starIcon: Texture;

    @property.texture({required: true})
    cupcakeIcon: Texture;

    @property.texture({required: true})
    rewardBackground: Texture;

    @property.texture({required: true})
    blob: Texture;

    @property.texture({required: true})
    seeingThings: Texture;

    @property.texture({required: true})
    comingSoonBanner: Texture;
    @property.texture({required: true})
    stageIsland: Texture;
    @property.texture({required: true})
    stageCandy: Texture;

    @property.material({required: true})
    uiTextOutline: Material;

    init() {
        if (UiTexturesManager._instance) {
            console.error('There can only be one instance of UiTexturesManager Component');
        }
        UiTexturesManager._instance = this;
    }
}
